import React from 'react';
import './price.scss';
import { umoksType } from '../../types/types.js';
import Parser from 'html-react-parser';
import { Link } from 'react-router-dom';

class Price extends React.Component {
  constructor(props) {
    super(props);
  };
  getTitle = () => {
    const { titlePrice } = this.props;

    return  titlePrice && titlePrice.front && Parser(titlePrice.front.title);
  };
  getList = () => {
    const {  titlePrice } = this.props;

    return titlePrice && titlePrice.front && (
      <div className='price-content-wrap'>
        {Parser(titlePrice.front.content)}
        <Link to='/home/category/consumer/prices'>Наші ціни</Link>
      </div>
    );
  };
  render() {
    return (
      <section className='price-wrap f-center'>
        {/*
        <div className='f-container'>
          <h2>{this.getTitle()}</h2>
         <div className='f-row'>
            <div className='f-item f-item-4 f-center'>
             <img src='../../img/consumer/sales.png' alt='sales' />
           </div>
           <div className='f-item f-item-8 f-center'>
             {this.getList()}
           </div>
          </div>
       </div>
        */}
      </section>
    );
  };
};

Price.propTypes = {
  sodToDayList:umoksType.isRequired
};


export default Price;



// WEBPACK FOOTER //
// ./src/client/components/price/price.jsx